import { FunctionComponent } from 'react'
import { Box, IconButton, makeStyles, TextField, Typography, Divider } from '@material-ui/core'
import { FileCopy } from '@material-ui/icons'
//@ts-ignore
import { useTheme } from 'styled-components'
import { useScreenSizes } from 'hooks/use-screen-sizes/useScreenSizes'
import { BackendUser } from 'common/types'
import { useAuth } from 'pages/auth/hooks/useAuth'
import { useAnalytics, AnalyticUserType } from 'hooks/use-analytics/useAnalytics'

const CopyInviteUrl: FunctionComponent<{ backendUser: BackendUser; notify: Function; partnerId: string }> = ({
  backendUser,
  notify,
  partnerId
}) => {
  const { isDevice } = useScreenSizes()
  const theme = useTheme()
  const useStyles = makeStyles({
    root: {
      borderColor: theme.colors.primary,
      borderStyle: 'dashed'
    }
  })
  const classes = useStyles()
  const { backendPartner } = useAuth()
  const { logEventAnalytics, handleTracker } = useAnalytics()

  return (
    <Box color={theme.colors.accent1} alignItems="center" display="flex" flexDirection="column" width="100%">
      <Typography variant="h5">
        <Box fontWeight="bold" marginTop="1em">
          {' '}
          Bring Your Community
        </Box>
      </Typography>

      <Typography component="p" variant="body2" align={isDevice ? 'center' : 'left'}>
        <Box fontWeight="bold">Friends don't let friends miss out on being on Obsidi.</Box>
      </Typography>
      <Typography component="p" variant="body2" align={isDevice ? 'center' : 'center'}>
        <Box fontWeight="bold">
          Invite your community to the home for Black professionals by sharing your unique URL
        </Box>
      </Typography>

      <Box display="flex" justifyContent="center" flexDirection="column" width="100%" marginTop="1em">
        <Divider style={{ backgroundColor: theme.colors.supplementary1, margin: '1.7em -1.5em' }} />
        <Box marginBottom="1em">
          <Typography component="p" variant="h5" align="center">
            <Box color={theme.colors.primary} fontWeight="bold">
              Invite your tribe to Obsidi
            </Box>
          </Typography>
          <Typography component="p" variant="body2" align="center">
            <Box color={theme.colors.accent1} fontWeight="bold">
              Copy and share the link below to invite your peeps to sign up on Obsidi
            </Box>
          </Typography>
        </Box>
        <TextField
          value={`https://${window.location.host}/profile/${backendUser?.id}?connect=true`}
          color={theme.colors.primary}
          InputProps={{
            endAdornment: (
              <IconButton
                onClick={() => {
                  navigator.clipboard.writeText(
                    `https://${window.location.host}/profile/${backendUser?.id}?connect=true`
                  )
                  notify('success', 'URL copied to clipboard')

                  const partnerLog = {}
                  const userLog = {}
                  userLog['User ID'] = backendUser?.id
                  if (backendUser?.partnerId) {
                    partnerLog['Partner ID'] = backendPartner?.id
                    partnerLog['Company Name'] = backendPartner?.name
                    partnerLog['Account Type'] = 'Partner'
                  } else {
                    userLog['Account Type'] = backendUser?.role
                  }

                  logEventAnalytics(
                    backendUser?.partnerId ? 'Partner' : backendUser?.role,
                    'Obsidi invite clicks',
                    'mixpanel',
                    'Obsidi invite clicks',
                    { ...partnerLog, ...userLog },
                    backendUser?.id
                  )
                }}
              >
                <FileCopy color="primary" />
              </IconButton>
            ),
            disableUnderline: true,
            classes: {
              root: classes.root
            }
          }}
        />
        {partnerId && (
          <>
            <Divider style={{ backgroundColor: theme.colors.supplementary1, margin: '1.7em -1.5em' }} />
            <Box marginBottom="1em">
              <Typography component="p" variant="h5" align="center">
                <Box color={theme.colors.primary} fontWeight="bold">
                  Keep your community in the know. Invite them as followers
                </Box>
              </Typography>
              <Typography component="p" variant="body2" align="center">
                <Box color={theme.colors.accent1} fontWeight="bold">
                  Copy and share the link below to invite your peeps to follow your company page
                </Box>
              </Typography>
            </Box>
            <TextField
              value={`https://${window.location.host}/company/${partnerId}?follow=true`}
              color={theme.colors.primary}
              InputProps={{
                endAdornment: (
                  <IconButton
                    onClick={async () => {
                      navigator.clipboard.writeText(`https://${window.location.host}/company/${partnerId}?follow=true`)
                      notify('success', 'URL copied to clipboard')
                      const dataLog = {
                        'User ID': backendUser?.id,
                        'Partner ID': backendPartner?.id,
                        'Company Name': backendPartner?.name,
                        'Account Type': backendUser?.partnerId ? 'Partner' : backendUser?.role
                      }
                      await handleTracker(
                        AnalyticUserType.MEMBER,
                        'Obsidi follower invite clicks',
                        dataLog,
                        'mixpanel',
                        null,
                        backendUser
                      )
                    }}
                  >
                    <FileCopy color="primary" />
                  </IconButton>
                ),
                disableUnderline: true,
                classes: {
                  root: classes.root
                }
              }}
            />
          </>
        )}
      </Box>
    </Box>
  )
}

export default CopyInviteUrl
